import React from "react";

import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog/dialog";

type Props = {
	title: string;

	open: boolean;
	handleOpenChange: (open: boolean) => void;

	children: React.ReactNode;
};

/**
 * 料金プラン内で共通で使用するDialogコンポーネント（UIのレイアウトコンポーネント）
 */
export const PurchaseTicketDialog = ({ title, open, handleOpenChange, children }: Props) => {
	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent className="max-w-[800px]">
				<DialogHeader className="text-lg font-semibold">{title}</DialogHeader>

				{children}
			</DialogContent>
		</Dialog>
	);
};

PurchaseTicketDialog.displayName = "PurchaseTicketDialog";
